import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    ImageList,
    ImageListItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { httpRequest, printLog } from "../../helper/global";

let currentTinyMCECallback = null;

export const openImagePickerDialog = (tinymceCallback) => {
    return new Promise((resolve) => {
        currentTinyMCECallback = tinymceCallback; // Store the TinyMCE callback
    });
};

export default function ImageSelector({
    theme,
    open = false,
    onClose = null,
    imageList = [],
}) {
    const [selectedImage, setSelectedImage] = useState(null);

    const handleClose = () => {
        setSelectedImage(null);

        if (onClose) {
            onClose();
        }
    };

    const handleUseImage = () => {
        if (selectedImage) {
            // Do something with selectedImage, e.g., pass to parent or set elsewhere
            handleClose();
        }

        if (currentTinyMCECallback) {
            currentTinyMCECallback(selectedImage.value, {
                title: selectedImage.title,
            });
        }
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={"md"}
            >
                <DialogTitle>Select an Image</DialogTitle>
                <DialogContent>
                    <ImageList cols={3} gap={16}>
                        {imageList.map((img) => (
                            <ImageListItem
                                key={img.value}
                                sx={{
                                    border:
                                        selectedImage?.value === img.value
                                            ? "2px solid #1976d2"
                                            : "1px solid gray",
                                    cursor: "pointer",
                                    p: 1,
                                    backgroundColor:
                                        selectedImage?.value === img.value
                                            ? "#e3f2fd"
                                            : "lightgray",
                                }}
                                onClick={() => setSelectedImage(img)}
                            >
                                <img
                                    src={img.value}
                                    alt={img.title}
                                    style={{
                                        width: "100%",
                                        height: "180px",
                                        objectFit: "contain",
                                        display: "block",
                                    }}
                                    loading="lazy"
                                />
                                <div
                                    style={{
                                        textAlign: "center",
                                        marginTop: 8,
                                    }}
                                >
                                    {img.title}
                                </div>
                            </ImageListItem>
                        ))}
                    </ImageList>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        onClick={handleUseImage}
                        disabled={!selectedImage}
                        variant="contained"
                        color="primary"
                    >
                        Use Image
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
